import api from './axios';

export const sendEmailApi = async ({ to, subject, text }) => {
  try {
    const response = await api.post('/email/send', { to, subject, text });
    return response.data;
  } catch (err) {
    throw new Error('Failed to send email');
  }
};



